<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">List Reclass Category of Fixed Assets  
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="posting()">
              <i class="fa fa-paper-plane"></i> Posting
          </button>
          <button class="btn btn-primary mr-1" @click="printjv()">
              <i class="fa fa-print"></i> Print JV
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter" class="mb-1">
        <b-col lg="6">
            <b-row>
              <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>Reclass Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgldepr1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgldepr2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
            </b-row>    
            <b-row>
              <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>Reclass Description</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.uraian" ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="4">
                  <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Adj. # &nbsp;</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.nomor" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
            </b-row>    
              <b-row>
                <b-col lg="8">
                    <b-input-group >
                      <b-input-group-prepend><label>FA Group/Category</label></b-input-group-prepend>
                      <b-form-select v-model="tblData.catgid" :plain="true" :options="categories"></b-form-select>
                    </b-input-group>
                  </b-col>
                <b-col lg="4">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">PO # &nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.nomorpo" placeholder="Purch. Order#"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>            
        </b-col>
        <b-col lg="6">
              <b-row no-gutters>
                <b-col lg="5">
                    <b-input-group >
                      <b-input-group-prepend><label>FA Number | Description</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.asetid" placeholder="FA Number"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="7">
                      <b-form-input v-model="tblData.asdesc" placeholder="FA Name/Description"></b-form-input>
                </b-col>
              </b-row>                      
              <b-row no-gutters>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>FA Model/Type/Series</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.asmodel" placeholder="Model/Type/Series"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="3">
                      <b-form-input v-model="tblData.asserial" placeholder="Serial Number"></b-form-input>
                </b-col>
                <b-col lg="3" >
                    <b-button class="btn btn-secondary ml-3" @click="clearFilter()" > <i class="fa fa-eraser"></i> Clear Filter</b-button>
                </b-col>
              </b-row>                      
              <b-row no-gutters>
                <b-col lg="9">
                  <b-input-group >
                    <b-input-group-prepend><label>FA Acquisition Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="3" >
                    <b-button class="btn btn-success ml-3" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                </b-col>
              </b-row>                      
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
      >
        <template v-slot:cell(tanggal)="data">
          <div v-if="data.item.posting==0" style="background-color:yellow;">           
            {{data.item.tanggal| moment('D-MMM-YY')}} 
          </div>
          <div v-else> 
          {{data.item.tanggal| moment('D-MMM-YY')}} 
          </div>
        </template>
        <template v-slot:cell(aspurcpri)="data">
          {{data.item.aspurcpri|numFormat}}
        </template>
        <template v-slot:cell(depaccum)="data">
          {{data.item.depaccum|numFormat('0,0.00')}}
        </template>
        <template v-slot:cell(NilaiNett)="data">
          {{data.item.NilaiNett|numFormat('0,0.00')}}
        </template>

      </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-card v-if="showForm">
      <div slot="header">Form - Reclass Category  
        <div class="card-header-actions">
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row >
          <b-col lg="6" >
                <b-row no-gutters >
                  <b-col lg="5" >
                    <b-input-group class="pr-1">
                        <b-input-group-prepend><label>Fixed Asset</label></b-input-group-prepend>
                        <b-form-input v-model="model.asetid" readonly></b-form-input>  
                    </b-input-group>
                  </b-col>
                  <b-col lg="7">                            
                    <b-input-group >
                        <b-form-input v-model="model.asdesc" readonly></b-form-input>                                        
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuFixedAssetShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Model/type/Series</label></b-input-group-prepend>
                        <b-form-input v-model="model.asmodel" readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="2" >
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2">Year &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asyermad" readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="4">                            
                    <b-input-group >
                        <b-input-group-prepend class="d-md-inline d-lg-none"><label>S/N</label></b-input-group-prepend>
                        <b-input-group-prepend class="d-md-none d-lg-inline" style="margin-top: 6px !important;"><span>S/N &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asserial"  readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Original Cost (LCY)</label></b-input-group-prepend>
                        <b-input-group-prepend> <span class="input-group-text" style="width:80px !important;">{{uanguser}}</span></b-input-group-prepend>
                      <my-number class="form-control text-right" disabled separator="," v-model="model.aspurcpri" :precision="2"  readonly></my-number>
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Acquisition Date</label></b-input-group-prepend>
                        <b-form-input disabled v-model="model.asdatacq" type="date"  readonly></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-input-group >
                    <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                    <b-form-input v-model="model.catgname" readonly></b-form-input>                                        
                </b-input-group>

                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Accumulate Depreciated</label></b-input-group-prepend>
                        <b-input-group-prepend>
                          <span class="input-group-text pl-4 pr-4">{{uanguser}}</span>
                        </b-input-group-prepend>
                      <my-number class="form-control text-right" separator="," v-model="model.depaccumB4" :precision="2"  disabled></my-number>
                    </b-input-group>
                  </b-col>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Net Value Fixed Asset </label></b-input-group-prepend>
                        <b-input-group-prepend>
                          <span class="input-group-text pl-4 pr-4">{{uanguser}}</span>
                        </b-input-group-prepend>
                      <my-number class="form-control text-right" separator="," v-model="model.NilaiNettB4" :precision="2" readonly></my-number>
                    </b-input-group>
                  </b-col>
                </b-row>
          </b-col>
          <b-col lg="6" v-show="(model.asetkey)">
              <b-row>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Reclass Date</label></b-input-group-prepend>
                        <b-form-input v-model="model.tanggal" type="date" :state="!$v.model.tanggal.$error"></b-form-input>                                        
                    </b-input-group>
                  </b-col>
              </b-row>
                <b-input-group >
                    <b-input-group-prepend><label>Reclass Description</label></b-input-group-prepend>
                    <b-form-input v-model="model.uraian" :state="!$v.model.uraian.$error"></b-form-input>                                        
                </b-input-group>
                <b-input-group >
                        <b-input-group-prepend><label>NEW Group/Category</label></b-input-group-prepend>
                      <b-form-select v-model="model.catgidnew" :plain="true" :options="categoriesFrm" :state="!$v.model.catgidnew.$error"></b-form-select>
                </b-input-group>
              <div style="text-align:right;" class="mt-2">
                <button class="btn btn-primary mr-1" @click="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close</button>
              </div>

          </b-col>
        </b-row>
    </b-card>
        <b-modal v-model="lkuFixedAssetShow" size="lg" :hide-footer="true" title="List of Fixed Asset" :centered="true">
            <lku-fixedasset @click="onSelectLkuFixedAsset" outstand="1" :formdata="lkuFixedAssetData"></lku-fixedasset>
        </b-modal>    
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>     
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<style lang="scss">
    .list-of-fa_catgreclass {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: 120px;
        }
      }
    }
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import fa_catgreclass from "../../apis/fa_catgreclass";
import dropdown from "../../data/dropdown";
import myNumber from "../../components/my-number";
import lkuFixedasset from "../lookup/lkuFassetLazzy";
import { validationMixin } from "vuelidate";
import { required, minValue,numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading, myNumber, lkuFixedasset},
  mixins: [validationMixin],
  validations: {
        model: {
          tanggal: { required },
          uraian: { required },
          catgidnew: { required},
        },
  },
  data() {
    return {
      isLoading:false,
      lkuFixedAssetData:{},
      lkuFixedAssetShow: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      showReport:false,
      reportUrl: null,
      showList:true,
      showForm:false,
      showFilter:false,
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: null,
        sortDesc: false
      },
      terpilih:{tablekey:''},
      model: {tanggal:this.$store.state.user.tglaktif,uraian:'', catgidnew:'', uraian:''},
      uanguser:this.$store.state.user.matauang,
      YesNoAll: dropdown.YesNoAll,
      categories:[],
      categoriesFrm:[]
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "tanggal",
            thStyle: "width:80px",
            label: "Reclass<br> Date",
            sortable: true
          },
          {
            key: "uraian",
            label: "Reclass Description",
          },
          {
            key: "asetid",
            thStyle: "width:100px",
            label: "FA Number",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "asdesc",
            label: "FA Name/Description",
          },
          {
            key: "catgnamenew",
            thStyle: "width:150px",
            label: "New Category",
          },
          {
            key: "catgname",
            label: "Old Category",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "depaccum",
            label: "Old category<br>Accum.Depreciated ",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "masa",
            thStyle: "width:150px",
            label: "Old category<br>Depreciation Periode",
          },
          {
            key: "aspurcpri",
            label: "Aquisition Value",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "NilaiNett",
            label: "Nett Value Asset",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },

  },
  created: async function(){
      const [a] = await Promise.all([fa_catgreclass.category()]) ;
        this.categories = a.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
      
      this.categoriesFrm=a;
      // this.adjustGroups = b;
  },  
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await fa_catgreclass.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table)  this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.kodeacc= '';
        this.tblData.namaacc=  '';
        this.tblData.keterangan=  '';
        this.tblData.vendor=  '';
        this.tblData.DimVal=  '';
        this.refresh();
    },
    add: function(data) {
            for (var key in this.model) {
                this.model[key] = '';
            }
          this.showList=false;
         this.showForm=true;

    },
    edit: function() {
      if (this.terpilih.tablekey) {
          if (this.terpilih.tablekey==this.model.tablekey) {
              this.showForm=true;
              this.showList=false;
          } else {
            for (var key in this.terpilih) {
                this.model[key] = this.terpilih[key];
            }
            this.model.tanggal = moment(this.terpilih.tanggal).format('YYYY-MM-DD');
              this.showForm=true;
              this.showList=false;
          }
      } else {
            toastr.warn('Please select a row that want to be Edit!');
      }
    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.model);
              console.log('model : ',this.model);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              this.model.tanggal=moment(this.model.tanggal).format('YYYY-MM-DD');
              this.model.begdatecat=moment(this.model.begdatecat).format('YYYY-MM-DD');
              this.model.enddatecat=this.model.tanggal;

              await fa_catgreclass.save(this.model);
              this.model.tablekey='';
              this.closeFrm();    
              setTimeout(() => {
                  this.refresh();              
              }, 500);       

            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm() {
      if (this.terpilih.tablekey) {
        this.showDelConfirm = true;
      } else {
            toastr.warn('Please select a row that want to be Deleted!');
      }
    },
    deleteData: async function() {
          try {
            await fa_catgreclass.remove(this.terpilih);
            this.refresh();
          } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
          }
    },
    rowClicked(record, index) {
      if (this.terpilih.tablekey==record.tablekey) {
        console.log('terpilih row click: ', this.terpilih);
        this.edit();
      } else {
        if ((this.terpilih) && (this.terpilih._rowVariant)) {
            delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      }
    },
    posting: async function () {
      if (this.terpilih.tablekey) {
            if ((this.terpilih.posting || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.terpilih.posting == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    }, 
    postingData: async function(){
        this.isLoading=true;
        try {
            for (var key in this.terpilih) {
                this.model[key] = this.terpilih[key];
            }
            this.model.tanggal=moment(this.model.tanggal).format('YYYY-MM-DD');
            this.model.begdatecat=moment(this.model.begdatecat).format('YYYY-MM-DD');
            this.model.enddatecat=this.model.tanggal;

            await fa_catgreclass.posting(this.model);
            this.terpilih.posting=1;
            // this.printjv();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            for (var key in this.terpilih) {
                this.model[key] = this.terpilih[key];
            }
            this.model.tanggal=moment(this.model.tanggal).format('YYYY-MM-DD');
            this.model.begdatecat=moment(this.model.begdatecat).format('YYYY-MM-DD');
            this.model.enddatecat=this.model.tanggal;
            await fa_catgreclass.postingUndo(this.model);
            this.terpilih.posting=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printjv: async function()
    {
      if (this.model) {
          try {
              this.showReport=true;
              this.reportUrl= await fa_catgreclass.printjv(this.model);
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },

    onSelectLkuFixedAsset(lkuData) {
        this.lkuFixedAssetData=lkuData;
        this.lkuFixedAssetShow=false;
        this.model.asetkey = lkuData.selected.asetkey;
        this.model.asetid = lkuData.selected.asetid;
        this.model.asdesc = lkuData.selected.asdesc;
        this.model.lamathn = lkuData.selected.lamathn;
        this.model.lamabln = lkuData.selected.lamabln;
        this.model.depaccum = lkuData.selected.Penyusutan;
        this.model.catgid = lkuData.selected.catgid;
        this.model.catgname = lkuData.selected.catgname;
        this.model.matauang = lkuData.selected.matauang;
        this.model.asmodel = lkuData.selected.asmodel;
        this.model.asserial = lkuData.selected.asserial;
        this.model.asyermad = lkuData.selected.asyermad;
        this.model.supplierinfo = lkuData.selected.supplierinfo;
        this.model.aspurcpri = lkuData.selected.aspurcpri;
        this.model.asdatacq = moment(lkuData.selected.asdatacq).format('YYYY-MM-DD');
        this.model.tanggal=this.model.tanggal || this.$store.state.user.tglaktif;
        this.model.begdatecat=lkuData.selected.catgidstart;
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
